import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {FEATURE_USERS_CUSTOM_FIELDS} from "../../../../core/gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../const";

export default class CompanyUsersSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Company Users",
            description              : "",
            svgIcon                  : "isvg-manage-users",
            settingsUrl              : "o/users/list",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : "Company users",
            // feature                  : FEATURE_USERS_CUSTOM_FIELDS
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS
    }

}
